<template>
  <div class="dapp-box">
    <div class="m-title4" id="dapp">
      <!-- DAPP应用 -->aaaaaa
      {{ $t("dapp.box2T") }}
    </div>
    <div class="m-p">
      <!-- 一些polysmartchain.com团队现在喜欢的去中心化应用。下面是更多的去中心化应用。 -->
      {{ $t("dapp.box2ST") }}
    </div>
    <div class="box">
      <!-- v-for="(item, index) in $t('home.box6ItemList')" -->
      <div class="m-item3" v-for="(item, index) in list" :key="index">
        <div class="img">
          <img
            :src="require(`../../assets/images/v4/home/box6${index + 1}.png`)"
            alt=""
          />
        </div>
        <div class="t">{{ item.name }}</div>
        <div class="link"></div>
        <div class="p">
          {{ item.description }}
        </div>
        <div class="more">
          <span @click="uti.goPath(store.link.home.box6List[index])">
            {{ item.ft }}
            <svg class="icon" aria-hidden="true">
              <use xlink:href="#icon-arrowRight"></use>
            </svg>
          </span>
          <div
            class="copy hash"
            v-if="store.link.home.box6Dapp[index]"
            @click="doCopy()"
            :data-clipboard-text="store.link.home.box6Dapp[index]"
          >
            <!-- {{ $t("dapp.copy") }} -->
            {{ store.link.home.box6Dapp[index] }}
            <svg class="icon" aria-hidden="true">
              <use xlink:href="#icon-copy"></use>
            </svg>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Store from "../../store";
import Clipboard from "clipboard";
export default {
  data() {
    return {
      uti: Store.uti,
      store: Store.state,
      list: [
        {
          index: 1,
          type: "en,cn",
          image: "swap.png",
          name: "Swanswap",
          version: "1.0.7",
          address: "16GFVKFeCcweKQiS3MRQLc7o3YHhDgh8MT",
          description:
            "The liquidity hub of PolySmartChain, offering efficient matching and low-slippage trading experience.",
          official: true,
          url: "https://swanswap.polysmartchain.com/",
          platform:
            '[{name:"iOS",support:"true"},{name:"Androld",support:"true"},{name:"Web",support:"true"}]',
        },
        {
          index: 2,
          type: "en,cn",
          image: "farm.png",
          name: "Swanfarm",
          version: "1.0.9",
          address: "1BSuEF3L3No5aGoefKidaDQL6hKm2kBFhR",
          description:
            "As the yield aggregator of PolySmartChain, it helps users discover diversified DeFi earning opportunities and build a stable, sustainable source of passive income.",
          official: true,
          url: "https://pool.polysmartchain.com/",
          platform:
            '[{name:"iOS",support:"true"},{name:"Androld",support:"true"},{name:"Web",support:"true"}]',
        },
        {
          index: 3,
          type: "en,cn",
          image: "bridge.png",
          name: "Bridge",
          version: "1.0.0",
          address: "1EwcPzqsTq7YsWr48vWD1QPr6jHbn9WaTE",
          description:
            "The cross-chain bridge of PolySmartChain supports seamless migration of multi-chain assets—secure, convenient, and low-cost—building a truly interconnected cross-chain ecosystem.",
          official: true,
          url: "https://bridge.polysmartchain.com/",
          platform:
            '[{name:"iOS",support:"true"},{name:"Androld",support:"true"},{name:"Web",support:"true"}]',
        },
        {
          index: 5,
          type: "en,cn",
          image: "social.png",
          name: "Social",
          version: "3.6.4",
          address: "12mTgx1ju9mbdWEsjfMDDpvXfPUeGjmeVK",
          description:
            "PolySmartChain’s social mining pool integrates social interactions with incentive mechanisms. Users can mine by sharing—earn as you connect, igniting community engagement.",
          official: true,
          url: "https://social.polysmartchain.com/",
          platform:
            '[{name:"iOS",support:"true"},{name:"Androld",support:"true"},{name:"Web",support:"true"}]',
        },
        {
          index: 6,
          type: "en,cn",
          image: "polyjetclub.png",
          name: "PolyjetClub",
          version: "1.2.2",
          address: "1Dcscm4M48Uhfpfj7fvKa1u5KfxBKEYf5U",
          description:
            "Here, you can buy and trade pineapple avatars and potion bottles to unlock identity perks and advanced features. With one-click listings and instant transactions, build your own Polyjet digital collectibles economy.",
          official: true,
          url: "",
          platform: "",
        },
        {
          index: 7,
          type: "en,cn",
          image: "catpool_cn.png",
          name: "Catpool China",
          version: "2.1.1",
          address: "1La4wKoJoE1ABHTdSKVmKMWfBCjwhdvi4v",
          description:
            "The CAT Network mining pool tailored for Chinese-speaking communities offers deep integration with the CAT ecosystem—supporting node hosting, reward distribution, and technical guidance, enabling effortless decentralized mining.",
          official: true,
          url: "",
          platform: "",
        },
        {
          index: 8,
          type: "en",
          image: "catpool_global.png",
          name: "Catpool Global",
          version: "2.1.1",
          address: "1JjieJkL88E8jY2qECUc1FDfz2ZyCjCQd1",
          description:
            "Catpool Global is dedicated to providing sustained hashpower for the CAT network, building a global mining platform that is open to all, transparently rewarding, and highly efficient.",
          official: true,
          url: "",
          platform: "",
        },
        {
          index: 9,
          type: "en,cn",
          image: "protects.png",
          name: "Protect",
          version: "1.0.2",
          address: "1KDqy4WL9BTGm92xmWMnLUurdhPW8KotcA",
          description:
            "Enable with one click to prevent abnormal operations or asset theft. Multi-layer authentication and security strategies provide comprehensive protection for your on-chain assets.",
          official: true,
          url: "",
          platform: "",
        },
        {
          index: 10,
          type: "en,cn",
          image: "heartbeat.png",
          name: "Nodes heartbeat",
          version: "2.1.0",
          address: "1FiwtMPs8ywKUZtyWt4pXtf5tDrWw9ZZmX",
          description:
            "Continuously monitor the status of all nodes—offline status and latency are clear at a glance. You can also add your own nodes to track their performance and ensure uninterrupted rewards.",
          official: true,
          url: "",
          platform: "",
        },
        {
          index: 11,
          type: "en,cn",
          image: "bridge_air.png",
          name: "Bridge Air",
          version: "3.3.3",
          address: "14xVw3H6oPJvjf9YT57X9gaaSF8fRiKU8i",
          description:
            "Built on the CAT Network, the PolySmartChain cross-chain bridge enables secure, convenient, and low-cost transfers of assets across multiple chains—forming a truly interoperable ecosystem.",
          official: true,
          url: "",
          platform: "",
        },
      ],
    };
  },
  methods: {
    doCopy() {
      // console.log(cp);
      var clipboard = new Clipboard(".hash");
      // console.log(clipboard);
      clipboard.on("success", () => {
        this.$message.success("success");
        // 释放内存
        clipboard.destroy();
      });
      clipboard.on("error", () => {
        // 不支持复制

        this.$message.error("error");
        // 释放内存
        clipboard.destroy();
      });
    },
  },
};
</script>
<style lang="less" scoped>
.dapp-box {
  padding-top: (37 / 3.75vw);
  background-image: url("../../assets/images/v4/home/box2Bg.png");
  background-size: (225 / 3.75vw) (207 / 3.75vw);
  background-repeat: no-repeat;
  background-position: 0 60%, right 100%;
  text-align: center;
  .m-p {
    margin-top: (13 / 3.75vw);
  }

  .box {
    margin-top: 100px;
    // background-color: pink;
    width: 100%;
    // height: 500px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;

    .m-item3 {
      min-height: (316.67 / 3.75vw);
      .img {
        margin-top: (25 / 3.75vw);
      }
      .t {
        margin-top: (0 / 3.75vw);
      }
      .link {
        margin: (5 / 3.75vw) auto;
      }
      .more {
        .copy {
          margin-right: (20 / 3.75vw);
          white-space: nowrap;
          opacity: 0.5;
          margin-top: 10px;
        }
      }
    }
  }
}
</style>
